export default "__VITE_ASSET__BBUwXhr5__"